var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9587 7.04166h.0108m-11.38584-4.875H18.417c2.9915 0 5.4167 2.42513 5.4167 5.41667V18.4167c0 2.9915-2.4252 5.4166-5.4167 5.4166H7.58366c-2.99154 0-5.41667-2.4251-5.41667-5.4166V7.58333c0-2.99154 2.42513-5.41667 5.41667-5.41667zM17.3337 12.3175c.1337.9016-.0203 1.8224-.4401 2.6314-.4198.8091-1.084 1.4651-1.8982 1.8749-.8141.4098-1.7368.5524-2.6366.4076-.8999-.1448-1.7312-.5696-2.37573-1.2141-.6445-.6445-1.06937-1.4759-1.21417-2.3757-.1448-.8999-.00217-1.8226.40761-2.6367.40979-.8141 1.06589-1.47835 1.87489-1.89814.809-.41979 1.7298-.57379 2.6314-.4401.9197.13638 1.7711.56492 2.4285 1.22234.6574.6574 1.086 1.5088 1.2224 2.4285z",
    stroke: "#fff",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.0ce94512f1f236fe38c3f54f409a6b2f.svg";
export { ForwardRef as ReactComponent };